module.exports = __webpack_public_path__ + "static/media/OnlineBadge.18396c39.svg";